const CARRIER_URL_MAP: Record<string, (trackingNo: string) => string> = {
  ups: (t) => `https://www.ups.com/track?tracknum=${encodeURIComponent(t)}`,
  fedex: (t) => `https://www.fedex.com/fedextrack/?trknbr=${encodeURIComponent(t)}`,
  usps: (t) => `https://tools.usps.com/go/TrackConfirmAction?tLabels=${encodeURIComponent(t)}`,
  dhl: (t) =>
    `https://www.dhl.com/us-en/home/tracking/tracking-express.html?submit=1&tracking-id=${encodeURIComponent(t)}`,
};

export function getTrackingUrl(carrier: string, trackingNo: string): string | null {
  const key = carrier.toLowerCase().trim();
  const builder = CARRIER_URL_MAP[key];
  return builder ? builder(trackingNo) : null;
}
